<template>
  <div class="template-view">
    <header class="tv-header">
      <el-page-header @back="goBack" content="模板数据详情"></el-page-header>
    </header>
    <section class="tv-body">
      <template v-for="(item, index) in dataList">
        <div :key="index" class="tv-list">
          <div class="tvl-box">
            <p v-text="item.name" :title="item.name" class="tvl-title c-ellipsis"></p>
            <div class="tvl-view">
              <img :src="item.defaultUrl"/>
            </div>
            <div class="tvl-footer">
              <p class="tvl-desc">
                <!--<span>PV: {{item.editPv}}</span>-->
                <!--<span>UV: {{item.uv}}</span>-->
                <span>下载: {{item.downloadCount}}</span>
                <span>保存: {{item.saveCount}}</span>
              </p>
            </div>
          </div>
          <div class="module-divider" v-if="item.moduleList.length > 0"><span>方案组 》</span></div>
          <div v-for="(m , idx) in item.moduleList" :key="idx" class="tvl-box tvl-module"
               :class="{'first-module': idx === 0}">
            <p v-text="m.name" :title="m.name" class="tvl-title c-ellipsis"></p>
            <div class="tvl-view">
              <tpl-editor-area :disabled="true" v-model="m.json" :scale="m.scale"
                               :edit="false"></tpl-editor-area>
            </div>
            <div class="tvl-footer">
              <p class="tvl-desc">
                <span>下载: {{m.downloadCount}}</span>
                <span>保存: {{m.saveCount}}</span>
              </p>
            </div>
          </div>
        </div>
        <el-divider :key="`d_${index}`" v-if="dataList.length > 1"></el-divider>
      </template>
    </section>
    <no-result v-if="dataList.length === 0"></no-result>
  </div>
</template>
<script>
    import userDataService from '../../../request/service/userData-service'
    import noResult from '@/views/components/noResult'
    import tplEditorArea from '../../templateGroup/editor/tpl-editor-area';
    import util from '@/util.js';
    export default {
        components: {tplEditorArea, noResult},
        props:{
            tplGroupId: String,
            params:{
                type: Object, default(){
                    return {reqTime: '', startTimeFrom: '', startTimeTo: '', templateName: ''}
                }
            }
        },
        data() {
            return {
                dataList: []
            };
        },
        watch:{
            params:{
                handler(oldParams, newParams){
                    this.init();
                },
                deep: true
            },
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                if (this.tplGroupId) {
                    this.getData();
                }
            },
            getData() {
                let {reqTime, startTimeFrom, startTimeTo} = this.params;
                userDataService.getTemplateGroupView(this.tplGroupId, reqTime || '', startTimeFrom || '', startTimeTo || '').then((data) => {
                    data.forEach((item, index) => {
                        item.moduleList = [];
                    });
                    this.dataList = data;
                    this.getModule(data);
                });
            },
            getModule(templateList) {
                let {reqTime, startTimeFrom, startTimeTo} = this.params;
                templateList.forEach((item) => {
                    userDataService.getTemplateModuleView(item.id, reqTime || '', startTimeFrom || '', startTimeTo || '').then((data) => {
                        this.setModuleScale(data)
                        item.moduleList = item.moduleList.concat(data);
                    });
                })
            },
            setModuleScale(dataList){
                dataList.forEach((item) => {
                    item.scale = util.getScaleWidthAndHeight(200, 180, item.json.width, item.json.height)
                })
            },
            goBack(){
                this.$emit('input',  false);
            }
        }
    }
</script>
<style lang="scss">
  @import "./template-view";
</style>